"use client";

import type { ReactNode } from "react";
import { Authenticated, Unauthenticated } from "convex/react";
import { usePathname } from "next/navigation";

import { AppNavbar } from "@/components/app-shell/AppNavbar";
import { AppSectionTabs } from "@/components/app-shell/AppSectionTabs";
import { AppSidebar } from "@/components/app-shell/AppSidebar";
import { DashboardOverviewSection } from "@/components/app-shell/DashboardOverviewSection";
import { RedirectToLocalSignIn } from "@/components/RedirectToLocalSignIn";

export default function AuthenticatedLayout({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const showEmbeddedDashboard = pathname !== "/dashboard";

  return (
    <>
      <Authenticated>
        <div className="flex min-h-screen bg-background">
          <AppSidebar />
          <div className="flex min-h-screen flex-1 flex-col">
            <AppNavbar />
            <AppSectionTabs />
            <main className="flex-1 overflow-y-auto">
              {children}
              {showEmbeddedDashboard ? <DashboardOverviewSection embedded /> : null}
            </main>
          </div>
        </div>
      </Authenticated>
      <Unauthenticated>
        <RedirectToLocalSignIn />
      </Unauthenticated>
    </>
  );
}
